/**
 * 
 * @param {string} apiUrl - endpoint where images should be pulled from
 * @param {object} caseData - object of data returned from the api for a single case
 * @param {boolean} favoritedCase - whether the cases is favorited
 */
const CaseCard = (apiUrl, caseData, favoritedCase, currentCategoryName, practiceSEO) => {
    if (caseData.views.length > 0) {
        let firstCaseImage = caseData.views.sort((a, b) => a.view_number - b.view_number)[0];

        function generateSrcSetPhoto(singleView) {
            let singlePhoto = '<div>';

            for (var i = 0; i < singleView.images.length; i++) { 
                let currentImage = singleView.images[i];

                let thumbnail = currentImage.srcset.filter((imageItem) => imageItem.size.toLowerCase() === 'thumbnail')[0].path || undefined;
                let defaultThumbnail = currentImage.srcset.filter((imageItem) => (imageItem.size.toLowerCase() === 'detail'))[0].path || undefined;
                let detail = currentImage.srcset.filter((imageItem) => imageItem.size.toLowerCase() === 'large detail')[0].path || undefined;
                let altText = `${currentCategoryName} ${currentImage.type} Photo | ${practiceSEO.locality.city}, ${practiceSEO.locality.state} | ${practiceSEO.name}`;
                let wrapperClass = singleView.images.length == 1 ? 'single-photo' : 'double-photo';

                singlePhoto += `
                <div class="${wrapperClass}">
                    <img 
                        src="${ apiUrl }${ thumbnail }" 
                        srcset="${ apiUrl }${ defaultThumbnail } 1x,
                        ${ apiUrl }${ detail } 2x"
                        alt="${altText}"
                        title="${altText}" />
                </div>
                `;
            }

            singlePhoto += '</div>';
            return singlePhoto;
        }
        function truncateDescription(description, truncAmount) { // Currently unused
            let descHtml = $.parseHTML(description);
            let strippedDesc = '';

            $("*", descHtml).not('p').replaceWith(function() { return $(this).contents(); });
            $(descHtml).each(function() { strippedDesc += $.trim($(this).html()) + "~"; });
            return strippedDesc.substring(0,truncAmount).replace(/~/ig, '<br />') + "...";
        }
        window.galleryClickCard = function clickCard(element){
            if (!element.classList.contains('gallery-favorites') && !element.classList.contains('hide')) {
                let currentId = element.attributes['case-id'].value;

                $(element).closest('.case-card').children(`#case-card-${ currentId }`).trigger('click');
            }
        };

        //Populate Procedures Performed
        let proceduresList = '';
        caseData.case_categories.map((proc, i) => { 
            // Append all categories for "Procedures Performed"
            if(i !== 0 && proc.active && i < 5)
                proceduresList += ' &bull; ';
            if(proc.active && i < 5)
                proceduresList += proc.category_name; 
        });
        if(caseData.case_categories.length > 5)
            proceduresList += ` &bull; ${ caseData.case_categories.length - 6 } others`;
        return `
            <div class="case-card">
                <a href="${ caseData.canonical_url }" class="hide" id="case-card-${ caseData.case_id }"></a>
                
                <div class="case-card__inner">
                    <div class="case-card__image" case-id="${ caseData.case_id }" onclick="galleryClickCard(this)">
                        ${ generateSrcSetPhoto(firstCaseImage) } 
                    </div>
                    <div class="case-card__data" case-id="${ caseData.case_id }" onclick="galleryClickCard(this)">
                        <div class="card-data__content">
                            <p class="card-data__title">${ caseData.case_title || 'Case #' + caseData.case_id }</p>
                            <div class="card-data__description">${ caseData.case_description == null ?  '' : caseData.case_description}</div>
                        </div>
                        <div class="card-data__meta">
                            <p class="card-data__procedures">Procedure(s): ${ proceduresList }</p>`+
                            (caseData.surgeon_name ? `<p class="card-data__surgeon">Surgeon: ${caseData.surgeon_name}` : ``)+`</p>
                        </div>
                    </div>
                    <div class="case-card__footer">    
                        <p class="favorites gallery-favorites ${ (favoritedCase) ? 'active' : '' }" data-id="${ caseData.case_id }">
                            <span class="heart-icon ${ (favoritedCase) ? 'active' : '' }"></span>
                            <strong class="add">Add to favorites</strong> 
                            <strong class="favorite">Favorited</strong>
                        </p>
                    </div>
                </div>
            </div>
            `;
    } else {
        return '';
    }
};

export default CaseCard;


// WEBPACK FOOTER //
// ./src/scripts/site/components/CaseCard.js